import { TESTIMONIALS } from "@/mocks/gossip";

const PRINCIPLES = [
  { t: "先理时间线", d: "每个瓜先排关键节点，别让讨论跳到结论前面。", i: "ri-history-line" },
  { t: "再摆证据链", d: "首发、二次爆料、官方回应逐一标注，自己判断真伪。", i: "ri-verified-badge-line" },
  { t: "跟着更新走", d: "舆论每有转向就补充新节点，顺着持续更新读到最新。", i: "ri-refresh-line" },
];

export default function About() {
  return (
    <section id="about" className="bg-brand-500 text-paper-50 py-12 md:py-20 scroll-mt-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-6">
            <p className="text-sm font-semibold text-amber-300 mb-3 flex items-center gap-2">
              <i className="ri-information-line" /> 关于我们
            </p>
            <h2 className="font-heading font-black text-3xl md:text-4xl leading-tight">
              把"吃瓜"做成一门
              <br />
              有脉络的追踪。
            </h2>
            <p className="mt-5 text-paper-50/85 leading-relaxed text-[15px]">
              今日热瓜是一个面向中文网民的娱乐热点事件追踪站。我们不做标题党的情绪放大器，而是把散落在各平台的事件线索，
              按"发酵—爆料—反转—收尾"的进度结构化呈现。想看哪个瓜现在走到哪一步，顺着持续更新就能读。
            </p>
            <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {PRINCIPLES.map((p) => (
                <div key={p.t} className="rounded-xl bg-brand-600/50 border border-brand-400/40 p-4">
                  <i className={`${p.i} text-amber-300 text-xl`} />
                  <p className="font-bold text-paper-50 mt-2">{p.t}</p>
                  <p className="text-xs text-paper-50/75 mt-1 leading-relaxed">{p.d}</p>
                </div>
              ))}
            </div>
            <div className="mt-7 flex flex-wrap items-center gap-3 text-sm">
              <span className="text-paper-50/80">内容合作 · 线索投稿</span>
              <a
                href="mailto:contact@jinriregua.top"
                className="inline-flex items-center gap-1.5 px-4 h-9 rounded-full bg-paper-50 text-brand-700 font-semibold hover:bg-paper-100 whitespace-nowrap"
              >
                <i className="ri-mail-line" />
                contact@jinriregua.top
              </a>
            </div>
          </div>

          <div className="lg:col-span-6">
            <h3 className="font-heading font-bold text-xl mb-5 flex items-center gap-2">
              追瓜读者怎么说
              <span className="text-xs font-normal bg-brand-600/50 px-2 py-0.5 rounded-full">口碑留言</span>
            </h3>
            <div className="grid gap-4">
              {TESTIMONIALS.map((t) => (
                <figure key={t.name} className="rounded-2xl bg-paper-50 text-ink-900 p-5">
                  <div className="flex items-center gap-1 text-amber-500 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                  <blockquote className="text-sm text-ink-700 leading-relaxed">“{t.text}”</blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className="w-9 h-9 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center font-heading font-bold">
                      {t.name.slice(0, 1)}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-ink-900">{t.name}</p>
                      <p className="text-xs text-ink-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}